import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from '@carm/_utils/base.component';
import { CarmValidatorsList } from '@carm/_utils/error-handler/validations/carm-validators';
import { TermOptions } from '../modal/modal-data-model';

@Component({
  selector: 'carm-confirm-terms-dialog',
  templateUrl: './confirm-terms-dialog.component.html',
  styleUrls: ['./confirm-terms-dialog.component.scss']
})
export class ConfirmTermsDialogComponent extends BaseComponent implements OnInit {

  public title: string;
  public certifyTitle: string;
  public certifyText: string;
  public termsOption: TermOptions;
  public confirmForm: FormGroup;

  constructor(
    private fg: FormBuilder,
    public dialogRef: MatDialogRef<ConfirmTermsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title?: string, certifyTitle?: string, certifyText?: string, termsOption?: TermOptions }) {
      super();
      this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.prepareDialog();
    this.createForm();
  }

  private createForm(): void {
    this.confirmForm = this.fg.group({
      iCertify: [null, [CarmValidatorsList.required.validateFn()]]
    });
  }

  private prepareDialog(): void {
    this.title = this.data?.title ?? this.title;
    this.termsOption = this.data?.termsOption;
    this.certifyTitle = this.data?.certifyTitle;
    this.certifyText = this.data?.certifyText;
  }

  public accept(): void {
    this.confirmForm.markAllAsTouched();
    if (this.confirmForm.valid) {
      this.closeDialog(true);
    }
  }

  public cancel(): void {
    this.closeDialog(false);
  }

  private closeDialog(isAccepted): void {
    this.dialogRef.close({ accept: isAccepted });
  }
}
